<!-- surrounding <nav> tags will be projected in the host, see the navbar selector in .ts file -->
<!-- <nav > -->
<div class="container-fluid">
  <!-- TODO: Re add notifications here -->
  <a class="navbar-brand ms-2" routerLink="/dashboard">
    <img src="assets/euronext_securities-logo.svg" style="width:140px;" alt="Euronext Securities">
  </a>
  <button class="btn-nav btn-sidebar-toggle d-lg-none" type="button" (click)="toggleSidebar()">
    <i class="las fs-15 la-bars"></i>
  </button>
  <div class="navbar-collapse sidebar-navbar" [class.sidebar-navbar-open]="isSidebarOpen">
    <button class="btn-close btn-close-sidebar d-lg-none" (click)="toggleSidebar()">
      <i class="c-icon-close"></i>
    </button>
    <ul class="navbar-nav flex-fill">
      <li class="nav-item dropdown dropdown-user ms-lg-auto order-lg-1">
        <a
          class="nav-link dropdown-toggle no-caret"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          >
          <!-- Circle progress - Nick's design -->
          <svg class="timer" viewBox="0 0 36 36">
            <path
              attr.stroke-dasharray="{{ idlePercentage }}, 100"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            {{ userInitials }}
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <div class="px-4 px-lg-0 py-3 pt-lg-0">
              <h5 class="mb-0">{{ userFullName }}</h5>
              <!-- TODO: show last login data here -->
              <!-- @if (lastLogin) {
              <span class="text-faded fs-08"> Last login: {{ lastLogin }} </span>
              <br />
              } -->
              @if (sessionExpiresDiff) {
                <span class="text-faded fs-08">
                  Session expires in {{ sessionExpiresDiff | timeDiff }}
                </span>
              }
            </div>
            <div class="d-flex flex-column p-3 p-lg-0">
              <!-- TODO: Add theme selector here -->
              <a class="dropdown-item px-2 px-lg-4" routerLink="/update-user-profile">My profile</a>
              <a class="dropdown-item px-2 px-lg-4" routerLink="/change-password">Change Password</a>
              <a class="dropdown-item px-2 px-lg-4 text-error" (click)="logout()">Logout</a>
            </div>
          </div>
        </li>
        @if (viewBoProfilesPermission | checkPermissions) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/bo-profiles">BO Profiles</a>
          </li>
        }
        @if (viewBoFormsPermission | checkPermissions) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/documents">Documents</a>
          </li>
        }
        @if (taxCertTabPermissions | checkSomePermissions) {
          <li
            class="nav-item dropdown"
            acp-tax-certification-tab-dropdown
            [taxCertTabPermissions]="taxCertTabPermissions"
            >
            <!-- Tax Certification/TCS link list -->
          </li>
        }
        @if (reportingTabPermissions | checkSomePermissions) {
          <li
            class="nav-item dropdown"
            acp-reporting-tab-dropdown
            [reportingTabPermissions]="reportingTabPermissions"
            >
            <!-- Reporting link list -->
          </li>
        }
        @if (viewAuditsPermission | checkPermissions) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/audits">Audits</a>
          </li>
        }
        @if (viewManageDropdownPermision | checkPermissions) {
          <li
            class="nav-item dropdown"
            acp-manage-tab-dropdown
            [manageTabPermissions]="manageTabPermissions"
            [columnChecks]="columnChecks"
            >
            <!-- Manage -->
          </li>
        }
      </ul>
    </div>
    <div class="backdrop-bg" (click)="toggleSidebar()"></div>
  </div>
<!-- </nav> -->
